import React from 'react';
import Icon from '../../../components/AppIcon';

const SystemStatus = ({ services }) => {
  const getStatusColor = (status) => {
    const colors = {
      operational: 'var(--color-success)',
      degraded: 'var(--color-warning)',
      down: 'var(--color-error)'
    };
    return colors?.[status] || 'var(--color-muted-foreground)';
  };

  const getStatusText = (status) => {
    const texts = {
      operational: 'Çalışıyor',
      degraded: 'Yavaş',
      down: 'Çalışmıyor'
    };
    return texts?.[status] || 'Bilinmiyor';
  };

  const getStatusIcon = (status) => {
    const icons = {
      operational: 'CheckCircle2',
      degraded: 'AlertCircle',
      down: 'XCircle'
    };
    return icons?.[status] || 'HelpCircle';
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Sistem Durumu</h3>
        <Icon name="Server" size={20} color="var(--color-muted-foreground)" />
      </div>
      <div className="space-y-3">
        {services?.map((service) => (
          <div key={service?.id} className="flex items-center justify-between p-3 rounded-lg bg-muted/30">
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <Icon 
                name={service?.icon} 
                size={18} 
                color="var(--color-foreground)" 
                className="flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground truncate">{service?.name}</p>
                {service?.responseTime && (
                  <p className="text-xs text-muted-foreground">
                    Yanıt süresi: {service?.responseTime}ms
                  </p>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <Icon 
                name={getStatusIcon(service?.status)} 
                size={16} 
                color={getStatusColor(service?.status)} 
              />
              <span className="text-xs font-medium whitespace-nowrap" style={{ color: getStatusColor(service?.status) }}>
                {getStatusText(service?.status)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SystemStatus;